import React from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import { createPortal } from 'react-dom';
const InformationOverlay = _ref => {
  let {
    children,
    className,
    onCloseButtonClick,
    closeAriaLabel
  } = _ref;
  React.useEffect(() => {
    const websiteMainLayout = document.querySelector('.layout-container');
    if (!websiteMainLayout) {
      return () => {};
    }
    websiteMainLayout.setAttribute('inert', 'true');
    return () => {
      websiteMainLayout.removeAttribute('inert');
    };
  }, []);
  const {
    t
  } = useTranslation();
  const classNames = c('InformationOverlay', className);
  // eslint-disable-next-line function-paren-newline
  return /*#__PURE__*/createPortal(
  /*#__PURE__*/
  // eslint-disable-next-line react/jsx-indent
  React.createElement("div", {
    className: classNames
  }, /*#__PURE__*/React.createElement("nav", null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    "aria-label": closeAriaLabel || t('information_overlay.close'),
    className: "small-close-button",
    onClick: onCloseButtonClick
  })), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "u-indent--large"
  }, children))), document.body);
};
export default InformationOverlay;